var freezeTransitionsResizeTimer;


jQuery(document).ready(function ($) {
    'use strict'

    /*
     * Remove `.freezeTransitions` class from the body
    */
    if ($('body').hasClass('freezeTransitions')) $('body').removeClass('freezeTransitions');

    // Invoke mobile menu
    if ($('.menuTrigger').length) {
        $.mtcMobileMenu({
            move_site: true,
            position: 'top',
            is_fixed: false
        })
    }

    // Remove HTML5 validation
    if ($('form').length) $('form').attr('novalidate', 'novalidate')

    // Animate all top links
    $('a[href="#top"]').on('click', function () {
        $('html, body').animate({
            scrollTop: 0
        }, 'slow')
        return false;
    })

    /**
     *  Scroll to
     */
    if ($('.js_scrollTo').length) {
        $('.js_scrollTo').on('click', function (e) {
            e.preventDefault();

            var thisHref = $(this).attr("href");

            if ($(thisHref)[0]) {
                var offset = $(thisHref).offset();

                $('html, body').animate({
                    scrollTop: offset.top
                }, 'slow');
            }

            return false;
        })
    }

    /*
     * Google Map
     */
    $(window).on("scroll mouseover touchstart", function() {
        if ($(".js_MapMultiple").length > 0) {
            $(".js_MapMultiple").mtcGoogleMaps({
                styles: [ { "featureType": "administrative", "elementType": "labels", "stylers": [ { "visibility": "off" } ] }, { "featureType": "administrative.country", "elementType": "labels.text.fill", "stylers": [ { "color": "#2c52a2" } ] }, { "featureType": "administrative.province", "elementType": "labels.text.fill", "stylers": [ { "color": "#2c52a2" } ] }, { "featureType": "administrative.locality", "elementType": "labels.text.fill", "stylers": [ { "color": "#2c52a2" } ] }, { "featureType": "administrative.neighborhood", "elementType": "labels.text.fill", "stylers": [ { "color": "#2c52a2" } ] }, { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [ { "hue": "#ff0000" } ] }, { "featureType": "administrative.land_parcel", "elementType": "labels.text.stroke", "stylers": [ { "color": "#2c52a2" } ] }, { "featureType": "landscape", "elementType": "labels", "stylers": [ { "visibility": "off" } ] }, { "featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [ { "color": "#ecf6f9" } ] }, { "featureType": "landscape.natural", "elementType": "geometry.fill", "stylers": [ { "visibility": "on" }, { "color": "#e0efef" } ] }, { "featureType": "landscape.natural.landcover", "elementType": "geometry.fill", "stylers": [ { "color": "#ecf6f9" } ] }, { "featureType": "landscape.natural.terrain", "elementType": "geometry.fill", "stylers": [ { "visibility": "on" }, { "color": "#ecf6f9" } ] }, { "featureType": "poi", "elementType": "geometry.fill", "stylers": [ { "visibility": "on" }, { "hue": "#1900ff" }, { "color": "#c0e8e8" } ] }, { "featureType": "poi", "elementType": "labels", "stylers": [ { "visibility": "off" } ] }, { "featureType": "poi", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, { "featureType": "poi.attraction", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, { "featureType": "poi.business", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, { "featureType": "poi.government", "elementType": "labels", "stylers": [ { "visibility": "off" } ] }, { "featureType": "poi.medical", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [ { "color": "#ecf6f9" } ] }, { "featureType": "poi.park", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, { "featureType": "poi.place_of_worship", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, { "featureType": "poi.school", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, { "featureType": "poi.sports_complex", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road", "elementType": "geometry", "stylers": [ { "lightness": 100 }, { "visibility": "simplified" } ] }, { "featureType": "road", "elementType": "labels", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road", "elementType": "labels.text", "stylers": [ { "visibility": "on" }, { "color": "#00a2be" }, { "weight": "0.01" } ] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [ { "visibility": "on" }, { "lightness": 700 } ] }, { "featureType": "transit.station", "elementType": "labels", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "elementType": "all", "stylers": [ { "color": "#7dcdcd" } ] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [ { "color": "#addbf1" } ] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [ { "color": "#2c52a2" } ] }, { "featureType": "water", "elementType": "labels.text.stroke", "stylers": [ { "color": "#ffffff" } ] } ],
                marker: {
                    width: 68,
                    height: 83,
                    origin_x: 0,
                    origin_y: 0,
                    anchor_x: 34,
                    anchor_y: 83
                }
            });
        }
    });

    /*
     * js_shareUrl
     */
    $('.js_shareUrl').on('click', function (e) {
        e.preventDefault();

        navigator.clipboard.writeText(window.location.href);

        alert("Linked Copied!");
    });
}) // document ready

/*
 * Stop transitions on resize
 */
$(window).on('resize', function (e) {
    'use strict'

    $('body').addClass('freezeTransitions');

    clearTimeout(freezeTransitionsResizeTimer);

    freezeTransitionsResizeTimer = setTimeout(function () {
        $('body').removeClass('freezeTransitions');
    }, 100);
});
